import { API_PREFIX_BIKE_TYPE_PATH } from "@/constants/prefix-path-api"
import { message } from "antd"
import { AxiosRequestConfig } from "axios"
import { HttpClient } from "../../../../app/api/HttpClient"
import { t } from "../../../../languages/i18n"
import { FilterSearchParams } from "../../../../lib/external-components"
import { BikeTypeAttributes } from "../../ui-builder/config/types"

export const fetchBikeTypes = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      pageSize: "20",
    },
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_BIKE_TYPE_PATH}`, { params })
    return response
  } catch (error) {
    message.error(t("Failed to fetch bike type"))
  }
}

export const updateBikeType = async (id: string, updatedData: BikeTypeAttributes) => {
  return await HttpClient.put(`${API_PREFIX_BIKE_TYPE_PATH}/${id}`, { data: updatedData })
}

export const createBikeType = async (data: BikeTypeAttributes) => {
  return await HttpClient.post(`${API_PREFIX_BIKE_TYPE_PATH}`, { data })
}

export const deleteBikeType = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_BIKE_TYPE_PATH}/${id}`)
}

export const getBikeTypeById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_BIKE_TYPE_PATH}/${id}`)
}

export const checkSlug = async (slug: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
  }
  return await HttpClient.get(`${API_PREFIX_BIKE_TYPE_PATH}`, { params })
}
